import React from "react"
import { useInView } from "react-intersection-observer"
import { PageDataLayer, pushToDataLayer } from "../tracking/page-data-layer"

export const usePageViewAnalytics = (pageDataLayer: PageDataLayer | undefined) => {
    const { ref } = useInView({
        onChange: (isVisible) => {
            if (!isVisible) return
            if (!pageDataLayer) return

            pushToDataLayer(pageDataLayer)
        },
        triggerOnce: true,
    })

    return { ref }
}

type Props = {
    data: PageDataLayer | undefined
}
export const PageViewAnalytics: React.FC<Props> = ({ data }) => {
    const { ref } = usePageViewAnalytics(data)

    return <div ref={ref} style={{ height: 0 }}></div>
}
